import styled from 'styled-components'

export const ActionsContainer = styled.div`
  margin-top: ${props => props.theme.whiteLabel.spacing.sp24};
`
